import Text from "@/components/Text"
import React from "react"
import { twMerge } from "tailwind-merge"


interface IMessageProps {
  title: string
  subtitle: string
  icon?: React.ReactNode
  condensed?: boolean
}

function Message ({ title, subtitle, icon, condensed = false }: IMessageProps) {
  return (
    <div className={twMerge("bg-darkglass rounded-xl text-center flex flex-col items-center p-4")}>
      {icon && <span>
        {icon}
      </span>}
      <Text size={condensed ? "sm" : "md"}>{title}</Text>
      <Text className="text-white/50 w-9/12 mx-auto" size={condensed ? "xs" : "sm"}>
        {subtitle}
      </Text>
    </div>
  )
}


export default Message